<template>
	<main>
		<div class="container">
			<div class="scroll" v-if="!loading">
				<h1 class="page-title">{{pageData.title}}</h1>
				<component :is="component.type" :data="component" v-for="(component, index) in widgets" :key="index"></component>
				<div class="widget accordion summary">
					<div class="header mb-3">
						<h2 class="date">{{formatedDate}}</h2>
						<button class="btn icon" @click="viewTrend()">
							<svg width="21" height="19">
								<g clip-path="url(#clip_0)">
									<path fill="rgb(255,255,255)" stroke="none" transform="translate(0 0.125885)" d="M6.16471 2.05827L3.48846 4.73452L3.48836 4.7346C2.72945 4.52127 1.92294 4.84699 1.52421 5.52714C1.1263 6.20729 1.23707 7.07041 1.79414 7.62748C2.35206 8.18539 3.21517 8.29615 3.89532 7.89824C4.57546 7.49949 4.90118 6.69218 4.68787 5.93408L7.26246 3.35864C7.65464 3.50632 8.08702 3.50632 8.47919 3.35864L11.0479 5.93408C10.8986 6.45671 11.0044 7.01954 11.3318 7.45355C11.66 7.88841 12.1719 8.14356 12.7167 8.14356C13.2607 8.14356 13.7726 7.88839 14.1008 7.45355C14.429 7.01954 14.534 6.45671 14.3847 5.93408L16.9601 3.36117C17.1537 3.43336 17.3588 3.47028 17.5648 3.47028C18.2671 3.47028 18.8996 3.04692 19.1679 2.39877C19.4362 1.74981 19.2877 1.00402 18.7913 0.50765C18.2941 0.011272 17.5475 -0.136399 16.8994 0.132697C16.2512 0.401792 15.8295 1.03517 15.8304 1.73748C15.8304 1.84496 15.841 1.95243 15.8615 2.05827L13.1861 4.732C12.8801 4.6475 12.5568 4.6475 12.2508 4.732L9.57121 2.05827C9.66555 1.55204 9.53019 1.03024 9.20037 0.633145C8.87135 0.236853 8.38319 0.00795768 7.86796 0.00795768C7.3527 0.00795768 6.86372 0.236874 6.53473 0.633145C6.20573 1.03026 6.06954 1.55204 6.16471 2.05827ZM7.09285 5.89622C6.65392 5.90032 6.30113 6.25723 6.30113 6.69615L6.30113 14.4124L9.45164 14.4124L9.45164 6.69615C9.45164 6.25393 9.09311 5.89622 8.6517 5.89622L7.09285 5.89622ZM16.5041 5.89622L18.0629 5.89622C18.5019 5.90031 18.8547 6.25723 18.8547 6.69615L18.8547 14.4124L15.7042 14.4124L15.7042 6.69615C15.7042 6.25393 16.0627 5.89622 16.5041 5.89622ZM1.53753 10.0354C1.53753 9.59395 1.89606 9.23542 2.33747 9.23542L3.88811 9.23542C4.32952 9.23542 4.68804 9.59395 4.68804 10.0354L4.68804 14.4125L1.53753 14.4125L1.53753 10.0354ZM13.2994 9.57181L11.7495 9.57181C11.5362 9.57099 11.3311 9.6555 11.1802 9.80647C11.03 9.95743 10.9455 10.1625 10.9471 10.3758L10.9471 14.4125L14.0977 14.4125L14.0977 10.3758C14.0985 10.1634 14.0148 9.95905 13.8655 9.8081C13.7153 9.65714 13.5118 9.57181 13.2994 9.57181ZM1.2602 15.7023L19.3231 15.7023C20.0189 15.7023 20.5833 16.2668 20.5833 16.9625C20.5833 17.6582 20.0189 18.2227 19.3231 18.2227L1.2602 18.2227C0.564466 18.2227 0 17.6582 0 16.9625C0 16.2668 0.564466 15.7023 1.2602 15.7023Z" fill-rule="evenodd"/>
								</g>
							</svg>
							<span>{{textView}}</span>
						</button>
					</div>
					<div class="card" :id="randomizeId" v-for="cat in symptomCategories" :key="cat">
						<div class="card-header" :id="'aria'+cat">
							<h5 class="mb-0" data-toggle="collapse" :data-target="'#collapse'+cat" aria-expanded="false" :aria-controls="'collapse'+randomizeId">
								{{cat}}
								<div>
									<span>{{catLenght(cat)}}</span>
									<svg width="12" height="7">
										<g clip-path="url(#clip_0)">
											<path fill="rgb(74,74,74)" stroke="none" transform="matrix(-4.37114e-08 -1 1 -4.37114e-08 0.045166 6.95871)" d="M1.83754 5.65475L6.21162 1.28067C6.50479 0.987505 6.50479 0.512505 6.21162 0.219877C5.91845 -0.0732925 5.44345 -0.0732925 5.15082 0.219877L0.410862 4.95983C0.341414 4.99482 0.275678 5.03776 0.21789 5.09555C0.0641524 5.24929 -0.00688048 5.45286 0.000529517 5.65484C-0.00689243 5.8563 0.0636149 6.05987 0.21789 6.21413C0.275674 6.27192 0.34194 6.31486 0.410862 6.34985L5.15082 11.0903C5.44399 11.383 5.91899 11.383 6.21162 11.0903C6.50479 10.7972 6.50479 10.3222 6.21162 10.029L1.83754 5.65475Z"/>
										</g>
									</svg>
								</div>
							</h5>
						</div>
						<div :id="'collapse'+cat" class="collapse" :aria-labelledby="'aria'+cat" :data-parent="'#'+randomizeId">
							<div class="card-body">
								<div class="symptom-desc" v-for="symptom in symptomsByCat(cat)" :key="symptom.id">
									<div>{{symptom.symptom}}</div>
									<div :class="'rate-'+symptom.pivot.rating">{{symptom.pivot.rating}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="h-align-center mt-5 mb-5">
					<button class="btn icon" @click="editSymptoms()">
						<svg width="26" height="26">
							<g clip-path="url(#clip_0)">
								<path fill="rgb(255,255,255)" stroke="none" transform="translate(3.67603 3.13873)" d="M21.4044 2.5685L21.4043 2.56844L19.4387 0.383853C19.0018 -0.108089 18.3469 -0.108089 17.855 0.274886L16.1072 1.85864L19.5476 5.68091L21.3493 4.09716C21.7862 3.71525 21.7862 3.00544 21.4044 2.5685ZM1.8567 15.0184L5.29709 18.8407L18.7299 6.44575L15.2895 2.62348L1.8567 15.0184ZM0 20.0966L0.982827 15.7283L4.47715 19.5507L0 20.0966Z" fill-rule="evenodd"/>
							</g>
							<g clip-path="url(#clip_1)">
								<path fill="rgb(255,255,255)" stroke="none" transform="translate(0.342041 0.108154)" d="M0 6.13997C0 5.56916 0.0783979 5.02588 0.20769 4.50733L0.207489 4.50746C0.803264 2.27912 2.61601 0.569433 4.92263 0.129292C5.31048 0.0522676 5.72587 0 6.16601 0C9.55932 0 12.3322 2.74549 12.3322 6.1662C12.3322 8.88687 10.5717 11.2182 8.10967 12.0215C7.51411 12.2292 6.84017 12.3323 6.16619 12.3323C3.16076 12.3323 0.621715 10.1563 0.103158 7.28022C0.0261334 6.89095 0 6.52923 0 6.13997ZM2.69449 5.44127L2.69449 6.5031L2.69586 6.84011L5.44125 6.84011L5.44125 9.61162L6.86621 9.61162L6.86621 6.86624L9.61297 6.86624L9.61297 5.44127L6.86621 5.44127L6.86621 2.69588L5.44125 2.69588L5.44125 5.44127L2.69449 5.44127Z" fill-rule="evenodd"/>
							</g>
						</svg>
						<span>{{textEdit}}</span>
					</button>
				</div>
			</div>
			<div class="loading" v-if="loading"><img src="/img/loading.gif"></div>
		</div>
	</main>
</template>

<script>
import Vue from "vue"
import CxltToastr from 'cxlt-vue2-toastr'
import 'cxlt-vue2-toastr/dist/css/cxlt-vue2-toastr.css'
import moment from 'moment'

Vue.use(CxltToastr, moment)

//importing widgets
import textcontent from '../../components/widgets/text'

export default {
	components: {
		textcontent
	},
	props:['id','date'],
	name: 'Summary',
	computed: { // setting list of widgets
		widgets() {
			return this.components
		},
		formatedDate() {
			return moment(this.date).format("MMMM Do, YYYY")
		},
		randomizeId: function() {
			return 'accordion'+Math.floor(Math.random() * 100) + 1
		}
	},
	data() {
		return {
			ps:null,
			pageData:[],
			components:[],
			comp:[],
			profile: this.$route.params.id,
			symptoms:[],
			symptomCategories:[],
			lang: localStorage.lang ? localStorage.lang  : 'en',
			textView: localStorage.lang =='en' ? 'View Trend' : "Voir la tendance",
			textEdit: localStorage.lang =='en' ? 'Add / Edit Symptoms' : "Ajouter / Modifier des symptômes",
			loading:true
		}
	},
	mounted: function() {
		this.getPagedata()
	},
	methods: {
		getPagedata: function() { // getting current page data
			this.pageData = []
			this.components = []
			this.loading = true
			this.axios.get(process.env.VUE_APP_URL+'subsection/symptoms_summary', {params:{name:'symptoms_summary', language:this.lang}})
			.then(response => {
				this.pageData = response.data
				this.prepareComponents()
				this.getSymptomsList()
			})
			// .catch(error => {
			//   console.log(error)
			//   this.$router.push({name:'prevent'})
			// })
		},
		getSymptomsList: function() { // getting symptoms and parsing symptoms categories
			this.axios.defaults.headers.common['Authorization'] = localStorage.getItem('token')
			this.axios.get(process.env.VUE_APP_URL+'profile/'+this.id+'/symptoms', {params:{id:this.profile, date:this.$route.params.date, language:this.lang}})
			.then(response => {
				this.symptoms = response.data.symptoms
				this.symptoms.map(s => {
					let exist = false
					this.symptomCategories.map(c => {
						c == s.category ? exist = true : ''
					})
					!exist ? this.symptomCategories.push(s.category) : ''
				})
			})
		},
		symptomsByCat: function(cat) { // filtering symptoms by category name
			let list = []
			this.symptoms.map(s => {
				s.category == cat ? list.push(s) : ''
			})
			return list
		},
		catLenght: function(cat) {
			let count = 0
			this.symptoms.map(s => {
				s.category == cat ? count++ : ''
			})
			return count
		},
		editSymptoms:function() {
			this.$router.push({name:"rate", params:{id:this.profile, date:this.$route.params.date, type:'edit'}})
		},
		viewTrend:function() {
			this.$router.push({path:"/track/trend/"+this.profile, params:{id:this.profile}})
		},
		prepareComponents: function(){ // making widgets array
			if(this.pageData.text_contents && this.pageData.text_contents.length > 0) {
				this.pageData.text_contents.map(a => {
					a.type = 'textcontent'
					this.components.push(a)
				})
			}
			this.$nextTick(() => {
					this.sortComponents()
			})
		},
		sortComponents: function(){ // sorting widgets by index prop
			function compare(a,b) {
				if (a.index < b.index)
					return -1;
				if (a.index > b.index)
					return 1;
				return 0;
			}

			this.components = this.components.sort(compare)

			this.loading = false
			this.$nextTick(() => {
				this.perfectScrollInit()
			})
		},
		perfectScrollInit: function() { // perfect scroll init goes after dom update
			var container = document.querySelector('.scroll')
			if(!this.ps && container) {
				this.ps = new PerfectScrollbar(container)
			} else if(container) {
				this.ps.destroy()
				this.ps = null
				this.ps = new PerfectScrollbar(container)
				container.scrollTop = 0
			}
		}
	}
}

</script>